import Repository from '@/repositories/RepositoryFactory';
import ApiState from "../../enums/APISTATE";

const agreementRepository = Repository.get('agreementRepository');

export default ({
    namespaced: true,
    state: {
      agreements: [],
      agreementsApiState: ApiState.INIT,
      agreement: {},
      agreementApiState: ApiState.INIT,
      editingAgreement: null,
    },
    mutations: {
      setAgreementsApiState: (state, apiState) => {
        state.agreementsApiState = apiState;
      },
      setAgreements(state, response) {
        const { data } = response;
        state.agreements = data;
        state.agreementsApiState = ApiState.LOADED;
      },
      setAgreementApiState: (state, apiState) => {
        state.agreementApiState = apiState;
      },
      setAgreement(state, response) {
        const { data } = response;
        state.agreement = data;
        state.agreementApiState = ApiState.LOADED;
      },
      initialized(state, { agreements }) {
        state.agreements = agreements;
      }
    },
    actions: {
      async agreementById({ commit, dispatch }, dto) {
        dispatch('cancelEditingAgreement');
        commit('setAgreementApiState', ApiState.LOADING);
        try {
          commit('setAgreement', await agreementRepository.getById(dto.employeeId, dto.year));
        }
        catch (error) {
          console.error(error);
          commit('setAgreementApiState', ApiState.ERROR);
        }
      },
      async agreementByYear({ commit, dispatch }, dto) {
        dispatch('cancelEditingAgreement');
        commit('setAgreementsApiState', ApiState.LOADING);
        try {
          commit('setAgreements', await agreementRepository.getAllForYear(dto.year));
        }
        catch (error) {
          console.error(error);
          commit('setAgreementsApiState', ApiState.ERROR);
        }
      },
      async agreementUpdate({ commit, dispatch, state }, dto) {
        commit('setAgreementApiState', ApiState.LOADING);
        try {
          const response = await agreementRepository.update(dto);
          commit("setAgreement", response);
          dispatch('cancelEditingAgreement');
        }
        catch (error) {
          console.error(error);
          commit('setAgreementApiState', ApiState.ERROR);
        }
      },
      async agreementUpdateAll({ commit, dispatch, state }, dto) {
        commit('setAgreementsApiState', ApiState.LOADING);
        try {
          const response = await agreementRepository.updateAll(dto);
          commit("setAgreements", response)
        }
        catch (error) {
          console.error(error);
          commit('setAgreementsApiState', ApiState.ERROR);
        }
      },
      // Close the agreement sidebar
      cancelEditingAgreement({commit}) {
        commit('setAgreement', { data: null });
      },
      
      // Open the agreement sidebar
      startEditingAgreement({commit}, dto) {
        commit('setAgreement', { data: dto });
      }
    },
    getters: {
      agreementApiState(state) {
        return state.agreementApiState;
      },
      agreement(state) {
        return state.agreement;
      },
      agreementsApiState(state) {
        return state.agreementsApiState;
      },
      agreements(state) {
        return state.agreements;
      }
    }
  });